import FormFooter from "../../components/FormFooter";
import {useFormik} from "formik";
import * as Yup from 'yup';
import {useContext, useEffect, useState} from "react";
import {MyContext} from "../../context/myContext";
import FormikInput from "../../components/FormikInput";
import {useDispatch, useSelector} from "react-redux";
import {addRequest, selectRequestError, selectWaterType, setRequestStatus} from "./requestSlice";

const AddRequestForm = () => {
    const {showForm} = useContext(MyContext)
    const [name, setName] = useState('')
    const dispatch = useDispatch()
    const waterType = useSelector(selectWaterType)
    const error = useSelector(selectRequestError)

    const formik = useFormik({
        initialValues: {
            code: '', waterVolume: '', waterType: ''
        },
        validationSchema: Yup.object().shape({
            code: Yup.number().required('کد ملی را وارد کنید').typeError('ده رقم کد ملی را انگلیسی وارد کنید'),
            waterVolume: Yup.number().required('حجم آب را وارد کنید').typeError('به عدد وارد کنید'),
            waterType: Yup.string().required('نوع آب را وارد کنید')
        }),
        onSubmit: async (values) => {
            newRequest()
            formik.resetForm()
        }
    })

    function newRequest(){
        let nomadsList = JSON.parse(localStorage.getItem('nomads'))
        let filteredNomad = nomadsList.filter(item => item.national_code === formik.values.code)
        let nomadId = filteredNomad[0]?.nomad_id;
        const data = {
            created_at_user_id: localStorage.getItem('userId'),
            nomad_id: nomadId,
            water_type: formik.values.waterType,
            water_volume: formik.values.waterVolume
        }
        dispatch(addRequest({data, dispatch, waterType, formikWaterType: formik.values.waterType}))
    }

    useEffect(() => {
        formik.resetForm()
        setName('')
        dispatch(setRequestStatus({error: ''}))
        // eslint-disable-next-line
    }, [showForm === false])

    const handleOnFocusOut = () => { //To show name based on related code in name input after clicking outside code input
        let nomadsList = JSON.parse(localStorage.getItem('nomads'))
        let filteredNomad = nomadsList.filter(item => item.national_code === formik.values.code)
        let nomadName = filteredNomad[0]?.name;
        setName(nomadName)
        if(nomadName === undefined){
            setName('')
        }
    }

    const inputData = [
        {name: 'name', placeholder: 'نام(براساس کدملی)'}, {name: 'code', placeholder: 'کد ملی'}, {name: 'waterVolume', placeholder: 'حجم آب درخواستی(لیتر)'},
    ]

    return(
        <form className='add-request-form' onSubmit={formik.handleSubmit}>
            <div className='form-flex'>
                <FormikInput data={inputData} nameInRequest={name} formik={formik} handleChange={formik.handleChange} handleOnFocusOut={handleOnFocusOut} formType='addReqForm' />{/*This component represents three inputs*/}
                <div>
                    <select name='waterType' value={formik.values.waterType} onChange={formik.handleChange}>
                        <option value='' disabled>نوع آب درخواستی</option>
                        <option value={1}>آب شرب</option>
                        <option value={2}>آب دام</option>
                    </select>
                    <label>نوع آب<span>*</span></label>
                    {formik.touched.waterType && formik.errors.waterType ? <p className='error'>{formik.errors.waterType}</p> : null}
                </div>
                {error ? <p className='server-error'>{error}</p> : null}
            </div>
            <FormFooter />
        </form>
    )
}

export default AddRequestForm